import { SourceType, TaxInvoiceType } from "@/enums/enums";
import { SearchTaxFormModel, SearchTransactionModel } from "@/model/table/tableViewModel";
import { GetFileType } from "@/helper/shareHelper";

export function ConvertToPP30TransactionModel(pp30Transaction: any) {
  const multiplier = pp30Transaction.taxInvoiceType == TaxInvoiceType.CreditNote ? -1 : 1;
  const pp30TransactionModel = {
    contactId: pp30Transaction.contactId,
    contactCode: "",
    createDateTime: pp30Transaction.createDateTime,
    createUserId: pp30Transaction.createUserId,
    financeType: pp30Transaction.financeType,
    id: pp30Transaction.id,
    isDeleted: pp30Transaction.isDeleted,
    merchantId: pp30Transaction.merchantId,
    netTotal: pp30Transaction.netTotal.ToNumber() * multiplier,
    note: pp30Transaction.note,
    pp30Id: pp30Transaction.pp30Id,
    preVatTotal: pp30Transaction.preVatTotal.ToNumber() * multiplier,
    reference: pp30Transaction.reference,
    sourceId: pp30Transaction.sourceId,
    sourceType: pp30Transaction.sourceType,
    status: pp30Transaction.status,
    subTotal: pp30Transaction.subTotal.ToNumber() * multiplier,
    taxInvoiceDate: pp30Transaction.taxInvoiceDate,
    taxInvoiceNumber: pp30Transaction.taxInvoiceNumber,
    taxInvoiceType: pp30Transaction.taxInvoiceType,
    updateDateTime: pp30Transaction.updateDateTime,
    updateUserId: pp30Transaction.updateUserId,
    vatExemptedTotal: pp30Transaction.vatExemptedTotal.ToNumber() * multiplier,
    vatTotal: pp30Transaction.vatTotal.ToNumber() * multiplier,
    zeroVatTotal: pp30Transaction.zeroVatTotal.ToNumber() * multiplier,
  };

  return pp30TransactionModel;
}
export function ConvertToInsertPP30TransactionModel(pp30Transaction: any) {
  const pp30TransactionModel = {
    id: pp30Transaction.id ? pp30Transaction.id : 0,
    taxInvoiceNumber: pp30Transaction.taxInvoiceNumber.value,
    taxInvoiceDate: pp30Transaction.taxInvoiceDate.value.ToDateJsonString(),
    taxInvoiceType: pp30Transaction.taxInvoiceType,
    financeType: pp30Transaction.financeType,
    reference: pp30Transaction.reference.value,
    contactId: pp30Transaction.contact.value.id,
    note: pp30Transaction.note.value,
    vatExemptedTotal: pp30Transaction.vatExemptedTotal.value.ToNumber(),
    zeroVatTotal: pp30Transaction.zeroVatTotal.value.ToNumber(),
    preVatTotal: pp30Transaction.preVatTotal.value.ToNumber(),
    vatTotal: pp30Transaction.vatTotal.value.ToNumber(),
    subTotal:
      pp30Transaction.vatExemptedTotal.value.ToNumber() +
      pp30Transaction.zeroVatTotal.value.ToNumber() +
      pp30Transaction.preVatTotal.value.ToNumber(),
    netTotal:
      pp30Transaction.vatExemptedTotal.value.ToNumber() +
      pp30Transaction.zeroVatTotal.value.ToNumber() +
      pp30Transaction.preVatTotal.value.ToNumber() +
      pp30Transaction.vatTotal.value.ToNumber(),
  };

  return pp30TransactionModel;
}

export function ConvertToPP30TransactionTable(pp30Transaction: any) {
  const pp30TransactionTableList: any = [];

  if (pp30Transaction.tableDetailTransactionModelList && pp30Transaction.tableDetailTransactionModelList.length > 0) {
    pp30Transaction.tableDetailTransactionModelList.forEach((pp30TransactionTable: any) => {
      pp30TransactionTableList.push({
        financeType: pp30TransactionTable.financeType,
        id: pp30TransactionTable.id,
        netTotal: pp30TransactionTable.netTotal,
        note: pp30TransactionTable.note,
        preVatTotal: pp30TransactionTable.preVatTotal,
        reference: pp30TransactionTable.reference,
        sourceId: pp30TransactionTable.sourceId,
        sourceType: pp30TransactionTable.sourceType,
        status: pp30TransactionTable.status,
        subTotal: pp30TransactionTable.subTotal,
        taxInvoiceDate: pp30TransactionTable.taxInvoiceDate,
        taxInvoiceNumber: pp30TransactionTable.taxInvoiceNumber,
        taxInvoiceType: pp30TransactionTable.taxInvoiceType,
        vatExemptedTotal: pp30TransactionTable.vatExemptedTotal,
        vatTotal: pp30TransactionTable.vatTotal,
        zeroVatTotal: pp30TransactionTable.zeroVatTotal,
        isDeleted: pp30TransactionTable.isDeleted,
        contact: {
          contactBranchCode: pp30TransactionTable.contactModel.contactBranchCode,
          contactCode: pp30TransactionTable.contactModel.contactCode,
          contactFullName: pp30TransactionTable.contactModel.contactFullName,
          contactName: pp30TransactionTable.contactModel.contactName,
          contactType: pp30TransactionTable.contactModel.merchantType,
          contactId: pp30TransactionTable.contactModel.contactId,
          contactTaxId: pp30TransactionTable.contactModel.contactTaxId,
          logoUrl: pp30TransactionTable.contactModel.logoUrl,
        },
      });
    });
  }
  return pp30TransactionTableList;
}

export function GetContactIdListForPreparePP30Transaction(pp30TransactionList: Array<any>) {
  const contactIdList: Array<number> = [];

  if (pp30TransactionList && pp30TransactionList.length > 0) {
    pp30TransactionList.forEach((pp30Transaction: any) => {
      if (pp30Transaction.contactId > 0) {
        contactIdList.push(pp30Transaction.contactId);
      }
    });
  }

  return contactIdList;
}

export function ConvertToPP30TransactionTableAdvanceSearch(pp30TransactionList: Array<any>, contactList: Array<any>) {
  const pp30TransactionTableList: any = [];

  if (pp30TransactionList && pp30TransactionList.length > 0) {
    pp30TransactionList.forEach((pp30Transaction: any) => {
      let contact = null;
      const getContactbyId = contactList.find((x) => x.id == pp30Transaction.contactId);
      if (getContactbyId) {
        contact = {
          contactBranchCode: getContactbyId.contactBranchCode,
          contactCode: getContactbyId.contactCode,
          contactFullName: getContactbyId.contactFullName,
          contactName: getContactbyId.contactName,
          contactId: getContactbyId.id,
          contactTaxId: getContactbyId.contactTaxId,
          contactType: getContactbyId.contactType,
        };
      }
      pp30TransactionTableList.push({
        financeType: pp30Transaction.financeType,
        id: pp30Transaction.id,
        netTotal: pp30Transaction.netTotal,
        note: pp30Transaction.note,
        preVatTotal: pp30Transaction.preVatTotal,
        reference: pp30Transaction.reference,
        sourceId: pp30Transaction.sourceId,
        sourceType: pp30Transaction.sourceType,
        status: pp30Transaction.status,
        subTotal: pp30Transaction.subTotal,
        taxInvoiceDate: pp30Transaction.taxInvoiceDate,
        taxInvoiceNumber: pp30Transaction.taxInvoiceNumber,
        taxInvoiceType: pp30Transaction.taxInvoiceType,
        vatExemptedTotal: pp30Transaction.vatExemptedTotal,
        vatTotal: pp30Transaction.vatTotal,
        zeroVatTotal: pp30Transaction.zeroVatTotal,
        isDeleted: pp30Transaction.isDeleted,
        contact: contact,
      });
    });
  }

  return pp30TransactionTableList;
}

export function ConvertToSearchTransactionRequest(searchTransaction: any) {
  const searchTransactionRequest: SearchTransactionModel = {
    taxInvoiceNumber: searchTransaction.documentNumber ? searchTransaction.documentNumber : "",
    fromDate: searchTransaction.fromDate,
    toDate: searchTransaction.toDate,
    contactId: searchTransaction.contactId ? searchTransaction.contactId : 0,
    referenceNumber: searchTransaction.referenceNumber ? searchTransaction.referenceNumber : "",
    fromSubTotal: searchTransaction.fromSubTotal ? searchTransaction.fromSubTotal.ToNumber() : null,
    toSubTotal: searchTransaction.toSubTotal ? searchTransaction.toSubTotal.ToNumber() : null,
    fromVatTotal: searchTransaction.fromVatTotal ? searchTransaction.fromVatTotal.ToNumber() : null,
    toVatTotal: searchTransaction.toVatTotal ? searchTransaction.toVatTotal.ToNumber() : null,
    sourceTypeId: searchTransaction.sourceTypeId,
  };
  return searchTransactionRequest;
}

export function ConvertToSearchPP30FormRequest(searchTransaction: any) {
  const searchTransactionRequest: SearchTaxFormModel = {
    formNumber: searchTransaction.formNumber ? searchTransaction.formNumber : "",
    fromDate: searchTransaction.fromDate,
    toDate: searchTransaction.toDate,
    fromSalesTaxAmount: searchTransaction.fromSalesTaxAmount ? searchTransaction.fromSalesTaxAmount.ToNumber() : null,
    toSalesTaxAmount: searchTransaction.toSalesTaxAmount ? searchTransaction.toSalesTaxAmount.ToNumber() : null,
    fromPurchaseTaxAmount: searchTransaction.fromPurchaseTaxAmount
      ? searchTransaction.fromPurchaseTaxAmount.ToNumber()
      : null,
    toPurchaseTaxAmount: searchTransaction.toPurchaseTaxAmount
      ? searchTransaction.toPurchaseTaxAmount.ToNumber()
      : null,
    fromNetTaxCreditAmount: searchTransaction.fromNetTaxCreditAmount
      ? searchTransaction.fromNetTaxCreditAmount.ToNumber()
      : null,
    toNetTaxCreditAmount: searchTransaction.toNetTaxCreditAmount
      ? searchTransaction.toNetTaxCreditAmount.ToNumber()
      : null,
    filingType: searchTransaction.filingType,
  };
  return searchTransactionRequest;
}

export function ConvertToFileStoragePP30(fileStoragePP30List: Array<any>) {
  const fileStoragePP30: any = [];

  if (fileStoragePP30List.length > 0) {
    fileStoragePP30List.forEach((item: any) => {
      fileStoragePP30.push({
        createDateTime: item.uploadDateTime,
        fileFullUrl: item.fileUrl,
        fileName: item.fileName,
        name: item.fileName,
        fileType: item.fileContentType ? item.fileContentType : GetFileType(item.fileName),
        id: item.fileId,
        userId: item.uploadUserId,
      });
    });
  }
  return fileStoragePP30;
}

export function ConvertToClosingEntryPP30ModelFromMongo(_closingEntryPP30ModelFromMongo: any) {
  const closingEntryPP30ModelFromMongo = {
    journalModel: _closingEntryPP30ModelFromMongo.journalModel,
    expenseModel: _closingEntryPP30ModelFromMongo.expenseModel,
    pp30Id: _closingEntryPP30ModelFromMongo.pp30Id,
    isClosingEntry: _closingEntryPP30ModelFromMongo.isClosingEntry,
  };

  return closingEntryPP30ModelFromMongo;
}

export function ConvertToUpdateIsFiledPP30(_pp30IsFiledDetail: any, reference: string) {
  const pp30UpdateIsFiledOption = {
    pp30Id: _pp30IsFiledDetail.pp30Id,
    filedType: _pp30IsFiledDetail.filedType,
    reference: reference,
    isFiled: _pp30IsFiledDetail.isFiled,
    isPaid: _pp30IsFiledDetail.isPaid,
  };

  return pp30UpdateIsFiledOption;
}

export function ConvertToTaxInvoiceDetailListForTaxPP30(_taxInvoiceList: any) {
  const taxInvoiceList: any = [];
  if (_taxInvoiceList && _taxInvoiceList.length > 0) {
    _taxInvoiceList.forEach((_taxInvoiceItem: any) => {
      const taxInvoice = {
        id: _taxInvoiceItem.id,
        number: _taxInvoiceItem.number,
        preVatTotal: _taxInvoiceItem.preVatTotal,
        zeroVatTotal: _taxInvoiceItem.zeroVatTotal,
        vatExemptedTotal: _taxInvoiceItem.vatExemptedTotal,
        vatTotal: _taxInvoiceItem.vatTotal,
        netAmount: _taxInvoiceItem.netAmount,
        date: _taxInvoiceItem.date,
        isDeleted: _taxInvoiceItem.isDeleted,
      };
      taxInvoiceList.push(taxInvoice);
    });
  }

  return taxInvoiceList;
}

export function ConvertToCommentLogPP30(_commentList: Array<any>) {
  const commentList: any = [];

  if (_commentList.length > 0) {
    _commentList.forEach((item: any) => {
      commentList.push({
        actionDateTime: item.actionDateTime,
        actionUserId: item.actionUserId,
        commentId: item.commentId,
        commentLogType: item.commentLogType,
        data: item.data,
        note: item.note,
      });
    });
  }
  return commentList;
}

export function ConvertToTablDetailPP30FormModel(tablePP30Form: Array<any>) {
  const tableDetailPP30FormList: Array<any> = [];

  if (tablePP30Form && tablePP30Form.length > 0) {
    tablePP30Form.forEach((item) => {
      tableDetailPP30FormList.push({
        id: item.id,
        formNumber: item.formNumber,
        formDate: item.formDate,
        countSaleTransaction: item.countSaleTransaction,
        countPurchaseTransaction: item.countPurchaseTransaction,
        saleTotal: item.saleTotal,
        saleTaxAmount: item.saleTaxAmount,
        purchaseTotal: item.purchaseTotal,
        purchaseTaxAmount: item.purchaseTaxAmount,
        remainingTaxCreditAmount: item.remainingTaxCreditAmount,
        netTaxAmount: item.netTaxAmount,
        status: item.status,
        isFiled: item.isFiled,
        isPaid: item.isPaid,
        isClosingEntry: item.isClosingEntry,
        isDeleted: item.isDeleted,
      });
    });
  }

  return tableDetailPP30FormList;
}
